// Copyright Square, Inc.
// Generated using eventGen — https://github.com/squareup/cash-cdf
// Do not edit directly!
export var CUSTOMER_DATA_FRAMEWORK = {
    LIMITS: {
        STRING_PARAM_MAX_LENGTH: 4096
    }
};
